const reviews = [
  {
    name: "仙门桃桃",
    role: "宗门篇入坑第 3 年",
    text: "这里把宗门篇的时间线整理得特别清楚，每次追更到新剧情，先来翻一遍解析再回看旧章，很多伏笔一下就通了。",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20ink%20wash%20portrait%20of%20a%20young%20woman%20in%20cultivator%20robes%20with%20soft%20smile%2C%20warm%20cream%20background%2C%20minimal%20hand%20drawn%20brush%20style%2C%20elegant%20traditional%20xianxia%20mood&width=200&height=200&seq=avatar-review-01&orientation=squarish",
  },
  {
    name: "一剑镇山河",
    role: "追更党 · 伏笔猎手",
    text: "伏笔盘点那几篇是真有东西，作者藏的细节都被挖出来了。看完只想说，前文的每个眼神都没白给。",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20ink%20wash%20portrait%20of%20a%20confident%20young%20man%20cultivator%20in%20robes%2C%20warm%20cream%20background%2C%20minimal%20hand%20drawn%20brush%20style%2C%20elegant%20traditional%20xianxia%20mood&width=200&height=200&seq=avatar-review-02&orientation=squarish",
  },
  {
    name: "炼丹的猫",
    role: "境界设定爱好者",
    text: "修炼境界那篇讲得又全又清楚，把金丹为什么是分水岭讲透了。跟同好一起讨论，追更再也不孤单。",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20ink%20wash%20portrait%20of%20a%20gentle%20young%20woman%20cultivator%20holding%20a%20small%20cat%2C%20warm%20cream%20background%2C%20minimal%20hand%20drawn%20brush%20style%2C%20cozy%20traditional%20xianxia%20mood&width=200&height=200&seq=avatar-review-03&orientation=squarish",
  },
];

export default function Testimonials() {
  return (
    <section className="container-x py-12 md:py-16">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-medium tracking-widest text-primary-600">同好口碑</p>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">追更路上，有人陪你</h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {reviews.map((r) => (
          <figure
            key={r.name}
            className="flex flex-col rounded-xl border border-background-200/70 bg-background-100/60 p-6"
          >
            <div className="flex gap-1 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">
              “{r.text}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
              <span className="h-10 w-10 overflow-hidden rounded-full">
                <img src={r.avatar} alt={`${r.name} 头像`} className="h-full w-full object-cover" />
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-900">{r.name}</span>
                <span className="block text-xs text-foreground-400">{r.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}